import { c as _c } from "react/compiler-runtime";
import { twMerge } from "tailwind-merge";
import { committeeInfo } from "@lib/committees";
import type { Committee } from "@lib/committees";
import { committeeBackground } from "@lib/styles/committees";
type CardHeaderProps = React.PropsWithChildren<{
  className?: string;
}>;
function CardHeader(t0) {
  const $ = _c(7);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = twMerge("w-full px-4 py-1", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <span>{children}</span>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
interface CommitteeHeaderProps {
  committee?: Committee | null;
}
export function CommitteeHeader(t0) {
  const $ = _c(5);
  const {
    committee
  } = t0;
  if (!committee) {
    return;
  }
  const info = committeeInfo[committee];
  const t1 = committeeBackground[committee];
  let t2;
  if ($[0] !== t1) {
    t2 = twMerge("text-slate-50", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== info.desc || $[3] !== t2) {
    t3 = <CardHeader className={t2}>{info.desc}</CardHeader>;
    $[2] = info.desc;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
type BaseCardProps = React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>;
export function Card(t0) {
  const $ = _c(10);
  let children;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      className: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = t1;
  } else {
    children = $[1];
    props = $[2];
    t1 = $[3];
  }
  const className = t1 === undefined ? "" : t1;
  let t2;
  if ($[4] !== className) {
    t2 = twMerge("overflow-hidden rounded-sm bg-white p-4 shadow-md", "dark:bg-slate-800", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== children || $[7] !== props || $[8] !== t2) {
    t3 = <div className={t2} {...props}>{children}</div>;
    $[6] = children;
    $[7] = props;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}